import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@mui/material";
import { Theme } from "@mui/material/styles";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import Typography from "@mui/material/Typography";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { Crew } from "./components/Crew/Crew";
import { Doc } from "./components/Doc/Doc";
import { IVR } from "./components/IVR/IVR";
import { Notes } from "./components/Notes/Notes";
import { OrderInfo } from "./components/OrderInfo/OrderInfo";
import { Recur } from "./components/Recur";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    pageHeading: {
      fontSize: theme.typography.pxToRem(20),
      color: "#000",
      lineHeight: "28px",
    },
    breadcrumbs: {
      fontSize: theme.typography.pxToRem(12),
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
    ".hidden": {
      overflow: "hidden",
    },
    accordionsSection: {
      overflow: "auto",
      //maxHeight: "calc(100vh - 42vh)",
      //maxHeight: "calc(100vh - 38vh)",
    },
    seeMoreBlock: {
      maxWidth: "150px",
    },
    moreInfoBlock: {
      width: "100%",
      display: "none",
      background: "#f6f6f6",
      position: "absolute",
      top: "40px",
      paddingBottom: "10px",
    },
    ".seeMoreBlock:hover > .moreInfoBlock": {
      background: "red",
    },
    cardMainParent: {
      float: "left",
      width: "100%",
    },
    tabCard: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    tabCardContent: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      boxShadow: "none",
      borderRadius: "0px",
    },
    cardMain: {
      marginBottom: "30px",
      paddingTop: "10px",
      width: "calc(100%)",
    },
  })
);

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};
export default function WorkOrder({}: Props): React.ReactElement {
  const classes = useStyles();
  const { id } = useParams<{ id: any }>();
  const [value, setValue] = useState(0);
  const { winHeight } = useMyWinHeightContext();
  const [expandedAccordion, setExpandedAccordion] = useState({
    orderInfo: false,
    recur: false,
    ivr: false,
    crew: false,
    notes: false,
    invoice: false,
    documents: false,
  });
  const [pageHeading, setPageHeading] = useState("Add a new Work Order");

  useEffect(() => {
    // Cleanup: Remove hidden class on unmount to prevent UI issues
    return () => {
      if (document.body.classList.contains("hidden")) {
        document.body.classList.remove("hidden");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      setPageHeading("Work Order Details");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  useEffect(() => {
    updateExpandedStatus(0);
  }, []);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setExpandedAccordion({
      ...expandedAccordion,
      orderInfo: newValue === 0,
      recur: newValue === 1,
      ivr: newValue === 2,
      crew: newValue === 3,
      notes: newValue === 4,
      documents: newValue === 5,
      invoice: newValue === 6,
    });
  };

  const updateExpandedStatus = (type: number) => {
    setValue(type);
    switch (type) {
      case 0:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            orderInfo: !prev.orderInfo,
          };
        });
        return;
      case 1:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            recur: !prev.recur,
          };
        });
        return;
      case 2:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            ivr: !prev.ivr,
          };
        });
        return;
      case 3:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            crew: !prev.crew,
          };
        });
        return;
      case 4:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            notes: !prev.notes,
          };
        });
        return;
      case 5:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            documents: !prev.documents,
          };
        });
        return;
      case 6:
        setExpandedAccordion((prev) => {
          return {
            ...prev,
            invoice: !prev.invoice,
          };
        });
        return;

      default:
        return;
    }
  };
  let wHeight = 0;
  const minHeight = 138;
  const minAccHeight = 193;
  const minTabHeight = 255;
  const minAddTabHeight = 60;
  let accordionMaxHeight = 0;
  let tabMinHeight = 0;
  wHeight = winHeight - minHeight;
  accordionMaxHeight = winHeight - minAccHeight;
  tabMinHeight = winHeight - minTabHeight;
  return (
    <>
      <TabHeader module={"Work Order"} heading={"Work Order Details"} />
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent} style={{ height: wHeight }}>
          <Paper elevation={3} className={classes.cardMain} style={{ height: wHeight }}>
            <Box pl={2} pr={2}>
              <Grid container direction="row">
                <Grid item xs={12} md={7}>
                  <Typography className={classes.pageHeading}>{pageHeading}</Typography>
                </Grid>
              </Grid>
            </Box>
            <Box m={1}>
              <Divider />
            </Box>

            <Grid container>
              <Grid item md={2} component={Card}>
                {id ? (
                  <CommonTabs
                    value={value}
                    handleChange={handleChange}
                    tabMinHeight={tabMinHeight}
                    minHeight={tabMinHeight + minAddTabHeight}
                  >
                    <Tab label="Work Order Information" {...a11yProps(0)} />
                    <Tab label="Recur Info" {...a11yProps(1)} />
                    <Tab label="IVR" {...a11yProps(2)} />
                    <Tab label="Crew" {...a11yProps(3)} />
                    <Tab label="Notes" {...a11yProps(4)} />
                    <Tab label="Documents" {...a11yProps(5)} />
                  </CommonTabs>
                ) : (
                  <CommonTabs value={value} handleChange={handleChange}>
                    <Tab label="Work Order Information" {...a11yProps(0)} />
                  </CommonTabs>
                )}
              </Grid>
              <Grid
                item
                md={10}
                component={Card}
                className={classes.tabCardContent}
                style={{ height: accordionMaxHeight, overflowY: "auto" }}
              >
                <Container>
                  <>
                    <OrderInfo
                      expand={expandedAccordion.orderInfo}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Recur
                      expand={expandedAccordion.recur}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <IVR expand={expandedAccordion.ivr} updateExpandStatus={updateExpandedStatus} />
                    <Crew
                      expand={expandedAccordion.crew}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Notes
                      expand={expandedAccordion.notes}
                      updateExpandStatus={updateExpandedStatus}
                    />
                    <Doc
                      expand={expandedAccordion.documents}
                      updateExpandStatus={updateExpandedStatus}
                    />
                  </>
                </Container>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
